import { render, staticRenderFns } from "./FuncDefault.vue?vue&type=template&id=4cdaa0bd"
import script from "./FuncDefault.vue?vue&type=script&lang=js"
export * from "./FuncDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports